import { type RovoContentBridgeAPIShape } from '@atlassian/rovo-content-bridge-api/dist/types/rovo-bridge-api-interface';
import { type ConfluenceDatabaseUpdateCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';

import { DatabaseStreamState } from '../database-stream-state';
import { sendDatabaseAIFCExperienceTrackingToParent } from '../metrics/rovo-bridge-metrics';

const streamState = DatabaseStreamState.getInstance();

export const editDatabase = (
  params: ConfluenceDatabaseUpdateCommandProperties,
  contentId: string,
  bridge: RovoContentBridgeAPIShape
) => {
  try {
    if (params.isStreamComplete) {
      streamState.completeStreaming();
      sendDatabaseAIFCExperienceTrackingToParent({
        status: 'success',
        bridge,
        experienceName: 'aiMateAifcAllDataHandled',
        contentId,
      });
      return;
    }

    if (!streamState.isStreamingActive) {
      sendDatabaseAIFCExperienceTrackingToParent({
        status: 'success',
        bridge,
        experienceName: 'aiMateAifcInitialDataReceived',
        contentId,
      });
      streamState.startStreaming(contentId, params.groupId, {
        operationType: 'edit',
      });
    }

    streamState.processChunk(params.data.document);
  } catch (possibleError) {
    const error =
      possibleError instanceof Error ? possibleError : new Error(String(possibleError));
    sendDatabaseAIFCExperienceTrackingToParent({
      status: 'fail',
      error,
      bridge,
      experienceName: 'aiMateAifcAllDataHandled',
      contentId,
    });
    throw error;
  }
};
